import axios from 'axios';
import { handleResponse } from '../helpers/handleResponse';


export const authenticationService = {
    login,
    logout,
    //currentUser: currentUserSubject.asObservable(),
    get token () { return localStorage.getItem('_jwt_token') }
};


function login(key: string) {
    return axios({
        method: 'post',
        url: '/api/auth/login',
        data: {authToken: key}
    }).then(handleResponse).then(data => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('_jwt_token', JSON.stringify(data));
        //currentUserSubject.next(user);

        return data;
    }).catch(err => {
        //setIsLoggedIn(false);
        //setIsLoading(false);
    });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('_jwt_token');
    //currentUserSubject.next(null);
}

